import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router';
import { Globals } from '../services/globals/globals';

/**
 * Resolver to check whether the app is in beta mode.
 * - side effect: sets isBeta on Globals service
 * @param route
 * @returns
 */
export const isBetaResolver: ResolveFn<boolean> = (
  route: ActivatedRouteSnapshot,
) => {
  const param = route.queryParamMap.get('beta');
  if (param === null) return false;

  const isBeta = param === 'true';
  inject(Globals).setIsBeta(isBeta);

  return isBeta;
};
